import { Route } from '@angular/router';
import { MediumExplorerComponent } from 'src/app/pages/media/medium-explorer/medium-explorer.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const mediumExplorer: Route = {
  path: 'medium-explorer',
  component: MediumExplorerComponent,
  title: 'nav.motives.motiveExplorer',
  data: {
    breadcrumb: 'nav.motives.motiveExplorer',
    icon: SbIcons.motiveExplorer,
    id: RoutingID.mediumExplorer,
  },
};
